export enum VendorEnum {
    ANDERSEN = "Andersen",
    BOSTIK = "Bostik",
    CERTAINTEED = "CertainTeed",
    CBB = "CBB",
    GAF = "GAF",
    JAMES_HARDIE = "JamesHardie",
    OWENS_CORNING = "OwensCorning",
    SIMONTON = "Simonton",
    TAMKO = "TAMKO",
    WESTLAKE_ROYAL = "Westlake Royal",
    WOLF = "Wolf"
}
